import { UpdateDobProofMaster } from "src/models/DobProofMaster.model";
import apiSlice from "./ApiSlice";

export const dobProofMasterApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL
    getDobProofMasterList: builder.query({
      providesTags: ["dob-proof-master"],
      query: () => ({
        url: "/dob-proof-master/admin/get-all",
        method: "GET",
      }),
    }),

    // ADD
    addDobProofMaster: builder.mutation({
      invalidatesTags: ["dob-proof-master"],
      query: (body) => ({
        url: "/dob-proof-master/add",
        method: "POST",
        body,
      }),
    }),

    // DELETE BY ID
    deleteDobProofMasterById: builder.mutation({
      invalidatesTags: ["dob-proof-master"],
      query: (id: string) => ({
        url: `/dob-proof-master/delete`,
        params: { id },
        method: "DELETE",
      }),
    }),

    // GET BY ID
    getDobProofMasterById: builder.query({
      providesTags: ["dob-proof-master"],
      query: (id: string) => ({
        url: `/dob-proof-master/view`,
        params: { id },
        method: "GET",
      }),
    }),

    // UPDATE
    updateDobProofMaster: builder.mutation({
      invalidatesTags: ["dob-proof-master"],
      query: ({ body, id }: UpdateDobProofMaster) => ({
        url: `/dob-proof-master/update`,
        params: { id },
        method: "PUT",
        body,
      }),
    }),

    // CHANGE STATUS
    changeDobProofMasterStatus: builder.mutation({
      invalidatesTags: ["dob-proof-master"],
      query: (id: string) => ({
        url: `/dob-proof-master/change-status`,
        params: { id },
        method: "PUT",
      }),
    }),
  }),
});

export const {
  useGetDobProofMasterListQuery,
  useAddDobProofMasterMutation,
  useDeleteDobProofMasterByIdMutation,
  useGetDobProofMasterByIdQuery,
  useUpdateDobProofMasterMutation,
  useChangeDobProofMasterStatusMutation,
} = dobProofMasterApi;
